import React, { memo, useEffect, useState } from 'react'
import { useNavigationContext } from '../../../providers'
import { util } from '../../../util'
import { Button, Icon, LeaveConfirmationModal, Typography } from '../index'

const SectionTitleCard = ({
    hideActions,
    showFlag,
    navigationKey,
    forceToggleDetails,
    statusConfig: { color, icon, sectionStatus, sectionStatusLocalized } = {},
    isSectionCompleted,
    renderCompletedView,
    title,
    onClickHandler,
    btnText,
    linkText,
    closeText,
    open,
}) => {
    const [tryingToClose, setTryingToClose] = useState(false)
    const navigation = useNavigationContext()

    useEffect(() => {
        forceToggleDetails && onClickHandler()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [forceToggleDetails])

    const actionClickHandler = text => {
        if (text === 'Close') {
            if (navigation.isComponentBlocked(navigationKey)) {
                setTryingToClose(true)
                return
            } else {
                onClickHandler(null, true)
                return
            }
        }
        onClickHandler(null, true)
    }

    /** If the section is completed but not opened then show the completed view of that section */
    const renderSectionCompletedView = () => {
        if (!open && isSectionCompleted) {
            return (
                <div className={'section-tile-card__completed-view'}>
                    <div className={'completed-content'}>
                        {!!renderCompletedView && renderCompletedView()}
                    </div>
                </div>
            )
        } else {
            return null
        }
    }

    const renderActionTypography = text => (
        <Typography
            size={'md'}
            text={text === 'Close' ? closeText : text}
            isUnderline
            color={'dark'}
            onClick={() => actionClickHandler(text)}
            hover={'pointer'}
        />
    )

    const renderSectionAction = () => {
        if (hideActions) {
            return null
        } else if (!open && !isSectionCompleted) {
            return (
                <Button color={'primary'} size={'sm'} onClick={onClickHandler}>
                    {btnText}
                </Button>
            )
        } else if (open) {
            return renderActionTypography('Close')
        } else {
            return renderActionTypography(linkText)
        }
    }

    const renderSectionStatus = () => {
        if (sectionStatus) {
            if (open && sectionStatus === 'NOT STARTED') {
                return null
            } else {
                return (
                    <div className={'section-tile-card__header__status'}>
                        <Icon color={color} renderIcon={icon} size={'sm'} margin={'ml-2 mr-2'} />
                        <Typography text={sectionStatusLocalized} size={'sm'} className={'mb-1'} />
                    </div>
                )
            }
        } else {
            return null
        }
    }

    const onLeave = () => {
        setTryingToClose(false)
        navigation.unblockComponent(navigationKey)
        onClickHandler()
    }

    const onCancel = () => {
        setTryingToClose(false)
    }

    return (
        <div className={'section-tile-card'}>
            <div className={'section-tile-card__header'}>
                <LeaveConfirmationModal
                    show={tryingToClose && navigation.isComponentBlocked(navigationKey)}
                    leaveClickHandler={onLeave}
                    cancelAlertModal={onCancel}
                />
                <Typography
                    className={'section-tile-card__header--title'}
                    fontType={'bold'}
                    text={title}
                    variant={'h2'}
                    size={'md'}
                />
                {renderSectionStatus()}
                <div className={'section-tile-card__header--flag'}>
                    {showFlag && (isSectionCompleted || open) && (
                        <Icon renderIcon={util.FlagIcon} color={'danger'} size={'xs'} />
                    )}
                </div>
                <div className={'section-tile-card__header__action'}>{renderSectionAction()}</div>
            </div>
            {renderSectionCompletedView()}
        </div>
    )
}

export default memo(SectionTitleCard)
